module.exports = __webpack_public_path__ + "health.jpg?0113d83477e09769e2bccabdc6d7de54";